import { prisma } from '../../shared/prisma';

export async function getNotifications(userId: string, page = 1) {
  const take = 20;
  const skip = (page - 1) * take;
  const [notifications, total] = await Promise.all([
    prisma.notification.findMany({
      where: { userId },
      orderBy: { createdAt: 'desc' },
      take,
      skip,
    }),
    prisma.notification.count({ where: { userId } }),
  ]);
  return { notifications, total, unread: await prisma.notification.count({ where: { userId, isRead: false } }) };
}

export async function markAllRead(userId: string) {
  return prisma.notification.updateMany({ where: { userId, isRead: false }, data: { isRead: true } });
}

export async function markRead(notifId: string, userId: string) {
  return prisma.notification.updateMany({ where: { id: notifId, userId }, data: { isRead: true } });
}

export async function createNotification(userId: string, type: string, payload: Record<string, unknown>) {
  return prisma.notification.create({ data: { userId, type: type as any, payload: payload as any } });
}
